import { UserOutlined, TeamOutlined, InboxOutlined, HomeOutlined } from '@ant-design/icons';
import { displayMessage } from '../../helpers/messages';

export const sideMenuItensIconsStyle = { fontSize: 20 };

export const topMenuItensIconsStyle = { fontSize: 20 };

const menus = {
  // Menus laterais para todos os usuários
  userSideMenuItens: [
    {
      key: '/users',
      icon: <UserOutlined style={sideMenuItensIconsStyle} />,
      title: displayMessage('USERS'),
    },
    {
      key: '/clients',
      icon: <TeamOutlined style={sideMenuItensIconsStyle} />,
      title: displayMessage('CLIENTS'),
    },
    {
      key: '/batches',
      icon: <InboxOutlined style={sideMenuItensIconsStyle} />,
      title: displayMessage('BATCHES'),
    },
  ],

  // Menus administrativos (se necessário)
  adminSideMenuItens: [],

  // Menus do topo (perfil, etc)
  topMenuItens: [
    {
      key: '/profile',
      icon: <UserOutlined style={topMenuItensIconsStyle} />,
      title: displayMessage('MY_PROFILE'),
    },
  ],
};

export default menus;



